import React from 'react'
import PropTypes from 'prop-types'
import RaisedButton from 'material-ui/RaisedButton'
import UserIcon from 'material-ui/svg-icons/action/assignment-ind'
import { withTheme } from 'styled-components'

import StyledMenuItem from './StyledMenuItem'
import InfoCard from '../../../components/InfoCardProfile'
import femaleAvatar from '../../../images/female.png'
import maletAvatar from '../../../images/male.png'
import { getAvatarUrl } from '../../../utils/processUrl'
import { StyledProfileDrawer, DivProfile } from './styled-components'
import checkRole from '../../../utils/userRoles'
import AppConfig from '../../../utils/config'
const ProfileDrawer = props => {
  const {
    user,
    open,
    onLogout,
    onRequestChange,
    onViewProfile,
    onChangePassword,
    onAddNews,
    onListNews,
    theme,
    permissions
  } = props

  if (!user) {
    return null
  }

  const avatar =
    getAvatarUrl(user.Avatar) || (user.Sex && maletAvatar) || femaleAvatar

  return (
    <StyledProfileDrawer
      zDepth={1}
      openSecondary
      containerClassName="drawer-container"
      open={open}
      onRequestChange={onRequestChange}
      docked={false}>
      {user && (
        <DivProfile backgrounColor={theme.palette.primaryColor}>
          <InfoCard
            avatar={avatar}
            staffName={user.DisplayName}
            staffID={user.StaffId}
            email={user.Email}
            jobTitle={user.JobTitleName}
            department={user.DepartmentName}
          />

          <div style={{ textAlign: 'center', padding: '0 0 2rem 0' }}>
            <RaisedButton
              onClick={onViewProfile(user.EmployeeId)}
              labelStyle={{ color: theme.palette.accent1Color }}
              icon={<UserIcon style={{ fill: theme.palette.accent1Color }} />}
              label="View profile"
            />
          </div>
        </DivProfile>
      )}
      <br />
      {checkRole(permissions, AppConfig.permissions.ManageCms) && [
        <StyledMenuItem key="addNewPost" onClick={onAddNews()}>
          Add New Post
        </StyledMenuItem>,
        <StyledMenuItem key="viewMyPost" onClick={onListNews(user.EmployeeId)}>
          View My Post
        </StyledMenuItem>
      ]}
      {/* <StyledMenuItem onClick={onAddNews()}>Add New Post</StyledMenuItem>
      <StyledMenuItem onClick={onListNews(user.EmployeeId)}>
        View My Post
      </StyledMenuItem> */}
      <StyledMenuItem onClick={onChangePassword(user.EmployeeId)}>
        Change Password
      </StyledMenuItem>
      <StyledMenuItem onClick={onLogout}>Log out</StyledMenuItem>
    </StyledProfileDrawer>
  )
}

ProfileDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onRequestChange: PropTypes.func,
  onLogout: PropTypes.func.isRequired,
  onChangePassword: PropTypes.func.isRequired,
  user: PropTypes.object,
  onViewProfile: PropTypes.func.isRequired,
  onAddNews: PropTypes.func.isRequired,
  onListNews: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  permissions: PropTypes.array.isRequired
}

export default withTheme(ProfileDrawer)



// WEBPACK FOOTER //
// ./src/layouts/Authenticated/components/ProfileDrawer.js